import React from "react"
import LeftSloth from "../../assets/sloth/cat.png";

const RoadmapCard = (props) => {
    return(
        <div className="rounded-[16px] bg-[#68DDB0] grid lg:grid-cols-3 w-[80vw] lg:w-[720px] lg:h-[286px] gap-y-[20px] lg:gap-y-0 overflow-hidden lg:overflow-visible">

            <div>

                <img src={props.image} className='w-full lg:h-full origin-bottom-left object-cover scale-[1.15] lg:rounded-[16px]'/>

            </div>
            <div className="flex flex-col space-y-[25px] px-[24px] py-[30px] lg:col-span-2 justify-center order-first lg:order-last">

                <h3 className="body-1">
                    {props.title}
                </h3>

                <p className="body-2" dangerouslySetInnerHTML={{__html: props.copy}}>

                            </p>

            </div>
        </div>
    )
}

export default RoadmapCard